module.exports = __webpack_public_path__ + "img/ico_username_getstarted@3x.730336ef.png";